import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsDate, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { DtoLocation, IDtoLocation } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoLocationEntityDataService } from '../interfaces/dto.location.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoLocationEntityDataService extends EntityDataService<IDtoLocation> implements IDtoLocationEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  public getLocationsForDeviceAndDate$(deviceAccount: string, date: Date, encryptionString: string): Observable<IDtoLocation[]> {
    // Send the date as yyyy-MM-dd; interpolating the Date object would emit its
    // locale toString() (e.g. "Mon Jul 06 2026 ... GMT+0200"), which the backend
    // DateTime route binder cannot parse and rejects with HTTP 400.
    const dateString: string = UtilsDate.dateTimeToString(date).substring(0, 10);
    return this.httpGet(`/api/web/locations/${encodeURIComponent(deviceAccount)}/${dateString}/${encodeURIComponent(encryptionString)}`)
      .pipe(map((entities: IDtoLocation[]) => {
        const result: IDtoLocation[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getLocationsForDeviceAndDateAsync(deviceAccount: string, date: Date, encryptionString: string): Promise<IDtoLocation[]> {
    return (await this.getLocationsForDeviceAndDate$(deviceAccount, date, encryptionString).toPromise());
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('{0}/locations', this.configurationService.configData.urlApi);
  }

  protected override createEntityFromJson(json: any): IDtoLocation {
    const result: IDtoLocation = (UtilsJson.deserialize(json, DtoLocation) as IDtoLocation);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

  protected override doGetUrls(): IUtilsDictionary<string> {
    this._urls = super.doGetUrls();

    this._urls.add('get.by.device.date', UtilsString.stringFormat('{0}://{1}:{2}/{3}/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}/{1}/{2}');

    return this._urls;
  }

}
